import { useState, useEffect, useRef } from "react";
import React from "react";
import { workOrder } from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  downloadPDF,
  generateLocationToArray,
  getFileUrl,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import { format } from "date-fns";
import { data } from "jquery";
import Dropdown from "react-bootstrap/Dropdown";
import { TaskAction } from "../../components/TaskAction";
import { InventorySelector } from "../../components/InventorySelector";
import { WorkOrderLog } from "./Log";
import { useReactToPrint } from "react-to-print";
import WoPdf from "./pdf-export";

function WorkOrderDetail({ isRequest = false }) {
  const { id } = useParams();
  const editMode = !!id;
  const [status, setStatus] = useState("");
  const [options, setOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsRequest, setAttachmentsRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [assignType, setAssignType] = useState("individual");
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    start_date: "",
    due_date: "",
    status: "",
    description: "",
    title: "",
    fault: "",
    recurring_wo: "",
    priority: "medium",
    assigned_to: "",
    team_id: "",
    vendor_id: "",
    category_id: "",
    tasks: [],
    inventories: [],
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  async function getMasterData() {
    setIsLoading(true);
    try {
      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getMasterData();
  }, [id]);

  async function getRecord() {
    const result = await workOrder.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        asset_id: data.asset_id,
        start_date: format(new Date(data.start_date), "yyyy-MM-dd"),
        due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
        created_at: format(new Date(data.created_at), "yyyy-MM-dd"),
        status: data.status,
        description: data.description,
        title: data.title,
        fault: data.fault,
        recurring_wo: data.recurring_wo,
        priority: data.priority,
        assigned_to: data.assigned_to,
        team_id: data.team_id || "",
        vendor_id: data.vendor_id,
        category: data.category?.name,
        vendor: data.vendor?.vendor_name,
        assigned: data.team_id
          ? data.team?.team_name
          : data.assigned_to_user?.firstname,
        assignType: data.team_id ? "Team" : "Individual",
        asset: data.asset?.asset_name,
        tasks: data.tasks || [],
        inventories: data.inventories || [],
        request_document: data.request_document,
      };
      if (defaultValue.tasks.length > 0) {
        defaultValue.tasks.forEach((task) => {
          if (task.task_photo)
            task.url_full = renderImage(
              `machine/attachment/${task.task_photo}`
            );
        });
      }

      if (data.attachments) {
        // check if data.attachments is an object
        if (typeof data.attachments !== "object") {
          console.error("attachments is not an object");
          return;
        }
        const att = [];
        const attReq = [];
        if (data.attachments)
          Object.keys(data.attachments).forEach((key) => {
            if (data.attachments[key]) {
              const name = key.split("_")[3];
              const type = key.split("_")[2];
              const isRequest = key.split("_")[0] !== "workoder";
              const url = renderImage(
                `machine/attachment/${data.attachments[key]}`
              );
              const attachment = {
                name: name,
                type,
                url,
                value: data.attachments[key],
              };
              att.push(attachment);
              // if (!isRequest) {
              //
              // }else{
              //   attReq.push(attachment)
              // }
            }
          });
        setAttachments(att);
        setAttachmentsRequest(attReq);
      }
      setOptions(
        isRequest
          ? ["Pending", "Approved", "Declined"]
          : ["Open", "In Progress", "On Hold", "Completed"]
      );
      setStatus(isRequest ? data.request_status : data.status);
      console.log({ defaultValue });
      setDataToSend(defaultValue);
    }
  }

  const handleChangeStatus = async (v) => {
    try {
      let result;
      if (isRequest) {
        result = await workOrder.updateRequestStatus(id, { status: v });
      } else {
        result = await workOrder.updateStatus(id, { status: v });
      }

      if (result.ok) {
        toast.success("Status updated");
      } else {
        toast.error("Status failed to update");
      }
    } catch (e) {
      toast.error(e.message);
    }
    setStatus(v);
  };
  const componentRef = useRef();
  const downloadHandler = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Card className={"form-darker"}>
      <WoPdf
        open={openModal}
        setOpen={setOpenModal}
        data={dataToSend}
        attachments={attachments}
      ></WoPdf>

      <LoadingIndicator open={isLoading} />
      <CardHeader>
        <div className={"d-flex justify-content-between"}>
          <div>Work Order {isRequest ? "Request" : ""} Information</div>
          <div>
            <button
              onClick={() => setOpenModal(true)}
              className="btn btn-outline-theme btn-sm mx-1"
            >
              <i className="fa fa-eye"></i> Download PDF
            </button>
          </div>
        </div>
      </CardHeader>

      <CardBody>
        <div className="row g-1 mb-3 d-flex justify-content-end ">
          <div className="w-25">
            <Dropdown onSelect={handleChangeStatus}>
              <Dropdown.Toggle
                id="dropdown-basic"
                className={`w-100 btn btn-outline-${
                  isRequest
                    ? getRequestStatusColor(status)
                    : getStatusColor(status)
                }`}
                variant="outline"
              >
                {status}
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-100">
                {options.map((v, i) => (
                  <Dropdown.Item eventKey={v} key={v}>
                    {v}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* <div className="row g-1 mb-3 d-flex justify-content-end">

                            <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Dropdown button
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">




                    </div>
</div>

          </div> */}
        <div id="download-preview " className={"dark-print"} ref={componentRef}>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="workOrderTitle" className="form-label">
                  Work Order Title
                </label>
                <input
                  disabled
                  value={dataToSend["title"]}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="startDate" className="form-label">
                  Created Date
                </label>
                <input
                  disabled
                  value={dataToSend["created_at"]}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="startDate" className="form-label">
                  Start Date
                </label>
                <input
                  disabled
                  value={dataToSend["start_date"]}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="dueDate" className="form-label">
                  Due Date
                </label>
                <input
                  disabled
                  value={dataToSend["due_date"]}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="recurringWO" className="form-label">
                  Recurring WO
                </label>
                <input
                  disabled
                  value={dataToSend["recurring_wo"] || "No"}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="description" className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <input
                  disabled
                  value={dataToSend["description"]}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="asset" className="form-label">
                  Asset<span className="text-danger">*</span>
                </label>
                <input
                  disabled
                  value={dataToSend.asset}
                  className="form-control"
                  required
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="priority" className="form-label">
                  Priority
                </label>
                <input
                  disabled
                  value={dataToSend["priority"]}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="priority" className="form-label">
                  Category
                </label>
                <input
                  disabled
                  value={dataToSend.category}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="priority" className="form-label">
                  Fault / Suspected Issue
                </label>
                <input
                  disabled
                  value={dataToSend.fault}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="assignee" className="form-label">
                  Assignee Type
                </label>
                <input
                  disabled
                  value={dataToSend.assignType}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="assignee" className="form-label">
                  Assigned to
                </label>
                <input
                  disabled
                  value={dataToSend.assigned}
                  className="form-control"
                  required
                />
              </div>
            </div>
          </div>
          {attachments.length > 0 && (
            <div className="mb-3">
              <Card>
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Attachments
                </CardHeader>
                <CardBody>
                  <div className="row">
                    {attachments.map((attachment, index) => (
                      <div key={index} className={"col-sm-4 position-relative"}>
                        {attachment.type === "image" && (
                          <ImageViewer
                            staticImage={attachment.url}
                            className={"img-fluid w-100"}
                            alt=""
                          />
                        )}
                        {attachment.type === "video" && (
                          <video
                            src={attachment.url}
                            className={"img-fluid w-100"}
                            width={"100%"}
                            controls
                          />
                        )}
                        {attachment.type === "pdf" && (
                          <iframe
                            src={attachment.url}
                            className={" w-100"}
                            width={"100%"}
                            height={"350px"}
                          />
                        )}
                        {attachment.type === "other" && (
                          <a
                            href={attachment.url}
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                              height: "200px",
                              paddingTop: "95px",
                              display: "block",
                            }}
                            className={
                              "border-theme border-1 border w-100 text-center"
                            }
                          >
                            Download the File
                          </a>
                        )}

                        <div className="my-2">
                          <input
                            type="text"
                            className={"form-control"}
                            value={attachment.name}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </div>
          )}
          <Card style={{ marginTop: "10px" }}>
            <LoadingIndicator open={isLoading} />
            <CardHeader>More Information</CardHeader>
            <CardBody>
              <label htmlFor="assignee" className="form-label">
                Vendor
              </label>
              <input
                disabled
                value={dataToSend.vendor}
                className="form-control"
                required
              />
            </CardBody>
          </Card>

          {!isRequest && (
            <TaskAction onChange={() => {}} value={dataToSend["tasks"]} />
          )}

          {!isRequest && (
            <div className="mt-2">
              <InventorySelector
                readOnly
                onChange={() => {}}
                value={dataToSend["inventories"]}
              />
            </div>
          )}

          <Card className="mt-2">
            <CardHeader>Photo / File</CardHeader>
            <CardBody>
              <div className="form-group">
                {!dataToSend.request_document && (
                  <p className="mt-2">- No File Uploaded -</p>
                )}

                {dataToSend.request_document && (
                  <p className="mt-2">
                    <a
                      href={getFileUrl(dataToSend.request_document.photo)}
                      target="_blank"
                    >
                      Here
                    </a>{" "}
                  </p>
                )}
              </div>
            </CardBody>
          </Card>

          <Card style={{ marginTop: "10px" }}>
            <LoadingIndicator open={isLoading} />
            <CardHeader>More Information</CardHeader>
            <CardBody>
              <label htmlFor="assignee" className="form-label">
                Vendor
              </label>
              <input
                disabled
                value={dataToSend.vendor}
                className="form-control"
                required
              />
            </CardBody>
          </Card>
        </div>
        <Card className="mb-4 mt-4">
          <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            Work Order Logs
          </CardHeader>
          <CardBody>
            {!isLoading ? (
              <WorkOrderLog work_order_id={id} updateLastLog={() => {}} />
            ) : null}
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  );
}

export default WorkOrderDetail;
